// extracted by mini-css-extract-plugin
module.exports = {"languageBar":"LanguageBar_languageBar__2H2Wp"};